module.exports = __webpack_public_path__ + "media/images/brand/meta_icons/apple-touch-icon-e96ffbf26642bedbfe9cb59866fccd09.png";